import { BadQuantity, ImportParser, QtyAndName } from './import-parser.interface';

export class SpaceDelimiterParser extends ImportParser {

    public parse(text: string): QtyAndName[] | null {
        const qtyAndNames = [];
        const rows = text.split('\n');
        let index = 0;
        for (const row of rows) {
            if (row.length === 0) {
                continue;
            }

            const split = row.split(' ');
            const qty = parseInt(split[0].trim(), 10);
            if (isNaN(qty)) {
                throw new BadQuantity(`${split[0]} is not a number, we are expecting it to be the quantity of cards`, index, index + split[0].length);
            }
            const name = split.slice(1).join(' ').trim();
            qtyAndNames.push({qty, name});
            index += row.length;
        }

        return qtyAndNames;
    }

}
